module.exports = __webpack_public_path__ + "static/media/6.467207e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/trolls-girl/heads/6.png
// module id = 73
// module chunks = 0